import { render, staticRenderFns } from "./RecentStoresCard.vue?vue&type=template&id=044a926c&scoped=true"
import script from "./RecentStoresCard.vue?vue&type=script&lang=js"
export * from "./RecentStoresCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044a926c",
  null
  
)

export default component.exports